import { FC } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  title: string
  image: string
  onClick: () => void
  badge?: string
}

export const ServiceTile: FC<Props> = ({ title, image, onClick, badge }) => (
  <button
    type="button"
    className={s.tile}
    onClick={onClick}
  >
    <img
      src={image}
      alt=""
      className={s.image}
    />

    <p className={clsx('semi-bold-12', s.title)}>{title}</p>

    {badge && <span className={clsx('semi-bold-9', s.badge)}>{badge}</span>}
  </button>
)
